






















import {Component, Vue} from "vue-property-decorator"
import ErrorMessage from "@/components/ErrorMessage.vue"
import {vxm} from "@/store"
import {Validation} from "@/lib/Validation"

@Component({components: {ErrorMessage}})
export default class SignUpVerifyCode extends Vue {

  private code: string = ""

  private errors: object = {}

  private loading: boolean = false

  async onVerify() {

    this.errors = {}
    if (!this.validate()) return

    try {
      this.loading = true
      await vxm.auth.verify({
        code: this.code
      })
      await this.$router.push({name: "SignIn"})
    } catch (e) {
      switch (e.code) {
        case "CodeMismatchException":
          this.errors = {code: ["Invalid code"]}
          break
        default:
          alert("不明なエラー")
          console.error(e)
      }
    } finally {
      this.loading = false
    }
  }

  validate(): boolean {

    const validation = new Validation({
      code: {
        required: true
      }
    })

    const check: boolean = validation.validate({
      code: this.code
    })

    if (!check) this.errors = validation.getErrors()

    return check
  }
}
